import React from 'react';
import './modal-contents-list.scss';
import { ModalContentItem } from './modal-content-item';
import { ModalContentItemData } from '../../types';
import { isEmpty } from 'lodash';

interface ModalContentsListProps {
  data: ModalContentItemData[];
  showSelection?: boolean;
  showArrow?: boolean;
  emptyView?: JSX.Element;
  endIcon?: JSX.Element;
}

export const ModalContentsList: React.FC<ModalContentsListProps> = ({
  data,
  showSelection = false,
  showArrow = false,
  emptyView,
  endIcon,
}) => {
  return (
    <div className="modal-contents-list">
      {isEmpty(data)
        ? emptyView
        : data.map((item, index) => (
            <ModalContentItem
              key={index}
              {...item}
              showSelection={showSelection}
              showDivider={data.length - 1 !== index}
              showArrow={showArrow}
              endIcon={endIcon}
            />
          ))}
    </div>
  );
};
